/** The Review app, where fast-track enrolment is managed. */
export const REVIEW_URL = "https://review.triangula.com";

export const reviewScoutUrl = (deviceId: string) => `${REVIEW_URL}/scouts/${deviceId}`;

export const REVIEW_ENROLLMENT_URL = `${REVIEW_URL}/enrollment`;
